import { ISearchService } from "@/lib/depict-client/interfaces/ISearchService"
import { IListingService } from "@/lib/depict-client/interfaces/IListingService"
import { IRecommendationsService } from "@/lib/depict-client/interfaces/IRecommendationsService"
import { IOtherService } from "@/lib/depict-client/interfaces/IOtherService"

export class DepictClient {
    constructor(
        public search: ISearchService,
        public listing: IListingService,
        public recommendations: IRecommendationsService,
        public other: IOtherService
    ) {}
}
